import React, {useEffect} from "react";
import { motion } from "framer-motion";
import Header from "../Components/Header";
import Hero from "../Components/Hero";
import SearchSection from "../Components/SearchBar";
import mapImg from '../Images/home-about.webp'
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import WhyChoose from "../Components/WhyChoose";
import whyChooseImg from '../Images/home-why-choose.webp'
import Services from "../Components/Services";
import ProcessSection from "../Components/Process";
import HomeBlogs from "../Components/HomeBlogs";
import FaqSection from "../Components/Faqs";
import { homeFaqs } from "../Data";
import Cta from "../Components/Cta";
import SchemaMarkup from "../Components/SchemaMarkup";
import businessSchema from "../Schemas/buisnessSchema";
import websiteSchema from '../Schemas/websiteSchems'
import faqSchema from "../Schemas/faqSchema";

const Home=()=>{
     useEffect(() => {
    document.title =
      "Perth Settlement Agents | LDL Settlement Services WA";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "LDL Settlement Services provides professional residential and commercial property settlements across Perth & Western Australia. Trusted settlement agents with over 20 years of experience."
      );
    }

    const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://ldlsettlementservices.com.au/");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "Perth Settlement Agents | LDL Settlement Services WA"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "LDL Settlement Services provides professional residential and commercial property settlements across Perth & Western Australia. Trusted settlement agents with over 20 years of experience."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://ldlsettlementservices.com.au/");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://ldlsettlementservices.com.au/Images/home-img.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "Perth Settlement Agents | LDL Settlement Services WA"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "LDL Settlement Services provides professional residential and commercial property settlements across Perth & Western Australia. Trusted settlement agents with over 20 years of experience."
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://ldlsettlementservices.com.au/Images/home-img.webp"
    );
  }
  }, []);

    const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.4,
  });

  const homeFaqSchema = faqSchema(homeFaqs);

    return(
        <>

        <SchemaMarkup schema={businessSchema} />
        <SchemaMarkup schema={websiteSchema} />
        {homeFaqSchema && (
  <SchemaMarkup schema={homeFaqSchema} />
)}

        {/**HEADER */}
        <Header />

        {/**HERO SECTION */}
        <Hero />

        {/**SEARCH BAR */}
        <SearchSection />

        {/**SERVICE CARDS SECTION */}
        <Services />

        {/**ABOUT US SECTION */}

<section className="home-about-section container">

  {/* LEFT IMAGE */}
  <motion.div
    className="home-about-left"
    initial={{
      opacity: 0,
      x: -70,
    }}
    whileInView={{
      opacity: 1,
      x: 0,
    }}
    transition={{
      duration: 1,
      ease: [0.22, 1, 0.36, 1],
    }}
    viewport={{
      once: true,
      amount: 0.25,
    }}
  >

    <motion.img
      src={mapImg}
      alt="About LDL Settlement Services"
      whileHover={{
        scale: 1.03,
      }}
      transition={{
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1],
      }}
    />

  </motion.div>

  {/* RIGHT CONTENT */}
  <motion.div
    className="home-about-right"
    initial="hidden"
    whileInView="visible"
    viewport={{
      once: true,
      amount: 0.2,
    }}
    variants={{
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.16,
        },
      },
    }}
  >

    {/* HEADING */}
    <motion.h2
      className="section-heading"
      variants={{
        hidden: {
          opacity: 0,
          y: 45,
        },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.9,
            ease: [0.22, 1, 0.36, 1],
          },
        },
      }}
    >
      About <span>LDL Settlement Services</span>
    </motion.h2>

    {/* TEXT */}
    <motion.p
      className="section-text"
      variants={{
        hidden: {
          opacity: 0,
          y: 35,
        },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 1,
            ease: [0.22, 1, 0.36, 1],
          },
        },
      }}
    >
      LDL Settlement Services is a trusted, highly reputable, and fully licensed Perth-based settlement agency providing professional, premium, end-to-end residential and commercial property settlement solutions across the entire length and breadth of Western Australia. We are deeply committed to uncompromising accuracy, total transparency, and attentive, personalised service—empowering and helping buyers, sellers, investors, and businesses alike navigate the often complex real estate settlement process with absolute confidence, clarity, and complete peace of mind.Our highly experienced team of conveyancing specialists meticulously manages every minor and major detail, from comprehensive contract reviews and digital property tracking to efficient electronic e-conveyancing and final settlement, ensuring a completely seamless, secure, and stress-free transaction from start to finish. Backed by decades of collective local industry knowledge and an unwavering commitment to clear, proactive communication, we deliver reliable, top-tier settlement services perfectly tailored to your unique property goals and financial milestones.
    </motion.p>

    {/* NUMBERS */}
    <motion.div
      className="numbers-box"
      ref={ref}
      variants={{
        hidden: {
          opacity: 0,
          y: 45,
        },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 1,
            staggerChildren: 0.12,
            ease: [0.22, 1, 0.36, 1],
          },
        },
      }}
    >

      {/* STAT 1 */}
      <motion.div
        className="stat"
        whileHover={{
          y: -6,
        }}
        transition={{
          duration: 0.3,
        }}
      >
        <h3>
          {inView && (
            <CountUp
              end={20}
              duration={2.5}
            />
          )}
          +
        </h3>

        <p>Years Of Experience</p>
      </motion.div>

      {/* STAT 2 */}
      <motion.div
        className="stat"
        whileHover={{
          y: -6,
        }}
        transition={{
          duration: 0.3,
        }}
      >
        <h3>
          {inView && (
            <CountUp
              end={10000}
              duration={2.5}
              separator=","
            />
          )}
          +
        </h3>

        <p>Settlements Completed</p>
      </motion.div>

      {/* STAT 3 */}
      <motion.div
        className="stat"
        whileHover={{
          y: -6,
        }}
        transition={{
          duration: 0.3,
        }}
      >
        <h3>
          {inView && (
            <CountUp
              end={4.3}
              decimals={1}
              duration={2.5}
            />
          )}
          +
        </h3>

        <p>Google Ratings</p>
      </motion.div>

      {/* STAT 4 */}
      <motion.div
        className="stat"
        whileHover={{
          y: -6,
        }}
        transition={{
          duration: 0.3,
        }}
      >
        <h3 className="wa-text">
          WA Wide
        </h3>

        <p>Your Local Experts</p>
      </motion.div>

    </motion.div>

  </motion.div>

</section> 

    {/**WHY CHOOSE US SECTION */}
    <WhyChoose
    image={whyChooseImg}
    desc="At LDL Settlement Services, we understand that every property transaction is a significant milestone and deserves careful attention, accuracy, and professional guidance. Whether you are updating ownership structures through a Change of Trustees, handling a family separation transfer, or navigating estate administration, our experienced team is committed to making the settlement process smooth, secure, and stress-free from start to finish. We pride ourselves on delivering personalised settlement solutions tailored to the unique needs of every client. Our team handles every aspect of the process with precision — including legal documentation, title searches, financial adjustments, liaising with banks, and coordinating with Landgate and other relevant parties. With clear communication and timely updates throughout the journey, we ensure you always feel informed and supported. Backed by strong local knowledge of Perth and Western Australia’s property regulations, LDL Settlement Services provides reliable advice and efficient settlement services you can trust. We focus on transparency, professionalism, and attention to detail, helping to minimise delays and avoid unnecessary complications. Our client-first approach means we take the time to understand your requirements and deliver practical solutions that make your property transaction as seamless as possible. From specialized Change of Trustees of Trusts applications, separation and divorce transfers pursuant to court orders, and transmission applications for deceased estates, we offer comprehensive support across a wide range of settlement services. At LDL Settlement Services, our goal is to provide peace of mind by ensuring every transaction is handled with care, integrity, and a commitment to achieving the best possible outcome for our clients."
    />

    {/**HOW WE MAKE IT EASY FOR YOU SECTION */}
    <ProcessSection />

    {/**BLOGS GRID */}
    <HomeBlogs />

    {/**FAQS SECTION */}
    <FaqSection
  title="Frequently Asked"
  highlightedText="Questions"
  desc="Stay informed with expert advice, market updates, and practical step-by-step guides designed to help you navigate your WA property journey with complete confidence."
  faqData={homeFaqs}
/>

          {/**CTA SECTION */}
          <Cta />
        </>
    )
}
export default Home;